import { render } from "./productNavigation.vue?vue&type=template&id=7ecba207"
import script from "./productNavigation.vue?vue&type=script&lang=js"
export * from "./productNavigation.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__